<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      filterCustomerSelected: [],
      selectAllCustomer: false,
      customer: {
        customer: [
          {
            customerId: 1,
            fullname: 'Superfood Group',
            email: 'admin_superfood@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Dimas Fariz',
            paymentTerms: 'Net 30',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 2,
            fullname: 'PT Interior Bersama',
            email: 'interior.bersama@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Alfian Yudistira',
            paymentTerms: 'Net 60',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 3,
            fullname: 'PT Medicarmasi',
            email: 'adm_medicarmasi@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Wilis Bagio',
            paymentTerms: 'Net 90',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 4,
            fullname: 'Foodistri',
            email: 'foodistri@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Adi Tjandra',
            paymentTerms: 'Net 30',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 5,
            fullname: 'Transportindo',
            email: 'log.transportindo@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Risman Satria',
            paymentTerms: 'Net 60',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 6,
            fullname: 'PT Adi Jaya',
            email: 'admin_adijaya@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Dimas Fariz',
            paymentTerms: 'Net 90',
            taxNo: '99.999.999.9-999.999',
          },
        ],
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      show_model: null,
      defaultField: ['fullname', 'email', 'companyCategories'],
      show: [
        { key: 'email', label: 'Email' },
        { key: 'companyCategories', label: this.$t('master.list.customer.industryCat') },
        { key: 'sales', label: this.$t('master.list.customer.marketingEmp') },
        { key: 'paymentTerms', label: this.$t('master.list.customer.top') },
        { key: 'taxNo', label: 'NPWP' },
      ],
      showModal: false,
      masterCustomer: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fullname',
          label: this.$t('master.list.customer.name'),
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'companyCategories',
          label: this.$t('master.list.customer.industryCat'),
          sortable: true,
        },
        {
          key: 'sales',
          label: this.$t('master.list.customer.marketingEmp'),
          sortable: true,
        },
        {
          key: 'paymentTerms',
          label: this.$t('master.list.customer.top'),
          sortable: true,
        },
        {
          key: 'taxNo',
          label: 'NPWP',
          sortable: true,
        },
      ],
      filteredItems: [],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      // return this.$t("setting.list.userSetting.pengaturanPengguna");
      return this.$t('master.pelanggan')
    },

    rows() {
      return this.customer.customer.length
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.masterCustomer.filter(function (item) {
          return item.key == 'check' || item.key == 'fullname' || result.includes(item.key)
        })
      } else {
        var defaultField = this.defaultField
        return this.masterCustomer.filter(function (item) {
          return item.key == 'check' || item.key == 'fullname' || defaultField.includes(item.key)
        })
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.customer.customer.length
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    toggleAll(event) {
      var checked = event.target.checked
      this.filterCustomerSelected = []
      if (checked) {
        this.filterCustomerSelected = this.customer.customer.map((item) => item.customerId)
      } else {
        this.filterCustomerSelected = []
      }
    },
    checkCustomer(event) {
      if (event.target.checked) {
        this.filterCustomerSelected.push(parseInt(event.target.value))
        if (this.filterCustomerSelected.length == this.customer.customer.length) {
          this.selectAllCustomer = true
        }
      } else {
        this.selectAllCustomer = false
        var index = this.filterCustomerSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterCustomerSelected.splice(index, 1)
        }
      }
    },
    clearDelete() {
      this.filterCustomerSelected = []
      this.selectAllCustomer = false
    },
    onRowClicked(item) {
      this.$router.push({
        name: 'Master Customer Detail',
        params: { id: item.customerId },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.textPelanggan') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Master Home Page' })"
          variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="mc-table-filter text-end">
          <b-button variant="primary" @click="$router.push({ name: 'Master Customer Create' })">
            <i class="mc-fa icon-outline_plus"></i>
            {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterCustomerSelected.length" class="mc-row-check">
              <span class="badge btn-success">{{ filterCustomerSelected.length }}</span>
              {{ $t('global.selectedRows') }}
              <a class="color-primary" @click="clearDelete">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              ></multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            sort-by="fullname"
            :fields="visibleFields"
            :items="customer.customer"
            class="datatables"
            responsive="md"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(check)>
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  v-model="selectAllCustomer"
                  @input="toggleAll"
                />
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.customerId"
                  v-model="filterCustomerSelected"
                  @input="checkCustomer"
                />
              </div>
            </template>

            <template #cell(fullname)="data">
              <strong class="text-primary">
                {{ data.item.fullname }}
              </strong>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                {{ $t('global.entry') }}
                <p>
                  {{ $t('global.show') }}&nbsp;<strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong
                  >&nbsp;&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp; {{ $t('global.until') }} &nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;{{ $t('global.entry') }}
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
